import React from "react"
import { Table, Button } from "antd"
import { PlusOutlined } from "@ant-design/icons"
import { useTranslation } from "react-i18next"
import { NewConfirmModal } from "ui/NewConfirmModal"
import { Text, Title } from "ui/Typography"
import AssignExperiencesModal from "ui/AssignExperiencesModal"
import AddOnModal from "./modal/AddOnModal"
import { useAddOns } from "./hooks/useAddOns"
import { getColumns } from "./columns"
import { ADD_ON_CONFIRM_COPY } from "./constants"
import useActiveGuide from "hooks/useActiveClient"
import styles from "../TaxesAndFees/index.module.css"

export const AddOnsSettings = () => {
  const { t } = useTranslation()
  const { isActive: active, isPending } = useActiveGuide()

  const {
    addOns,
    addOnsLoading,
    isCreating,
    isUpdating,
    isDeleting,
    isMutating,
    isModalOpen,
    addOnToEdit,
    handleAddAddOn,
    openAddModal,
    closeModal,
    getMenuItems,
    confirmAction,
    closeConfirm,
    handleConfirm,
    assignExpAddOn,
    openAssignExperiences,
    closeAssignExperiences,
    handleAssignExperiences
  } = useAddOns({ enabled: true })

  const copy = confirmAction ? ADD_ON_CONFIRM_COPY[confirmAction.type] : null

  return (
    <>
      <div className={styles.container}>
        <div className={styles.headerRow}>
          <div className={styles.titleWithInfo}>
            <Title level={4}>{t("settings.add_ons.section_title")}</Title>
          </div>
          <Button
            color="primary"
            variant="solid"
            icon={<PlusOutlined />}
            onClick={active && !isPending ? openAddModal : undefined}
            disabled={!active || isPending}
            aria-disabled={!active || isPending}
          >
            {t("settings.add_new")}
          </Button>
        </div>
        <Text className={styles.description}>
          {t("settings.add_ons.description")}
        </Text>
        <div className={styles.tableWrapper}>
          <Table
            columns={getColumns(getMenuItems, isMutating, t, openAssignExperiences)}
            dataSource={addOnsLoading ? undefined : addOns}
            rowKey="id"
            loading={addOnsLoading}
            pagination={false}
            locale={addOnsLoading ? { emptyText: <></> } : undefined}
          />
        </div>
      </div>

      <AddOnModal
        visible={isModalOpen}
        onCancel={closeModal}
        onSave={handleAddAddOn}
        initialValues={addOnToEdit}
        isSaving={isCreating || isUpdating}
      />
      <AssignExperiencesModal
        open={!!assignExpAddOn}
        onCancel={closeAssignExperiences}
        onSave={handleAssignExperiences}
        currentExperiences={assignExpAddOn?.associated_trips || []}
        loading={isUpdating}
      />
      <NewConfirmModal
        visible={!!confirmAction}
        onClose={closeConfirm}
        onConfirm={handleConfirm}
        title={copy ? t(copy.titleKey) : ""}
        message={copy ? t(copy.messageKey) : ""}
        highlightText={confirmAction?.addOn?.title}
        confirmLabel={copy ? t(copy.confirmKey) : ""}
        loading={isDeleting || isUpdating}
      />
    </>
  )
}

export default AddOnsSettings
